import { Web } from '@styled-icons/material';
import { MediaEmbedElement, MediaEmbedFileElement } from '@typedream/components';
import {
  DreamValue,
  MediaEmbedElement as MediaEmbedElementType,
} from '@typedream/core';
import { PlateRenderElementProps } from '@udecode/plate-core';
import { pick } from 'lodash';
import { DreamEditor } from '../../../types';

export function MediaEmbedElementEditor(
  props: PlateRenderElementProps<DreamValue, MediaEmbedElementType>,
) {
  const { editor: e, element, children } = props;

  const editor = e as DreamEditor;

  const isEmpty = !element.url && !element.html && !element.file;

  if (element.file) {
    return <MediaEmbedFileElement {...pick(props, ['element', 'className', 'attributes', 'children'])} />;
  }

  return (
    <MediaEmbedElement {...pick(props, ['element', 'className', 'attributes'])}>
      {isEmpty && (
        <div
          role="none"
          contentEditable={false}
          style={{
            userSelect: 'none',
            cursor: 'pointer',
            height: 50,
            margin: '10px 30px',
            paddingInline: 20,
            alignSelf: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 10,
            maxWidth: 'calc(100% - 60px)',
            color: 'var(--accent)',
            backgroundColor: 'var(--background-button)',
            boxShadow: 'var(--shadow-modal)',
            border: '1px solid var(--border-modal)',
            borderRadius: 10,
          }}
          onMouseDown={() => editor.emitter.emit('toolbar:toggle-replace-embed')}
        >
          <Web size={28} style={{ flexShrink: 0 }} />
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            Embed (HTML, Videos, Forms, Sites...)
          </span>
        </div>
      )}

      {children}
    </MediaEmbedElement>
  );
}
